(() => {
  'use strict';
  const storage = 'nuxero-community-popup-v2';
  const pending = 'nuxero-newsletter-pending';
  const save = () => { try { localStorage.setItem(storage, String(Date.now())); } catch (_) {} };
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form.matches?.('.nx-newsletter form') || !form.checkValidity()) return;
    try { sessionStorage.setItem(pending, JSON.stringify({ id: form.id, time: Date.now() })); } catch (_) {}
    form.setAttribute('aria-busy', 'true');
    const status = form.querySelector('.nx-form-status[hidden]');
    if (status) status.hidden = false;
    form.querySelectorAll('button[type="submit"]').forEach(button => { button.disabled = true; });
    setTimeout(() => {
      form.removeAttribute('aria-busy');
      if (status) status.hidden = true;
      form.querySelectorAll('button[type="submit"]').forEach(button => { button.disabled = false; });
    }, 15000);
  });
  const init = () => {
    const modal = document.getElementById('NuxeroCommunityPopup');
    if (!modal || modal.dataset.nxReady) return;
    modal.dataset.nxReady = 'true';
    const opener = document.querySelector('[data-nx-newsletter-open]');
    modal.querySelector('[data-nx-later]')?.addEventListener('click', () => { save(); modal.hide(); });
    modal.querySelector('[id^="ModalClose-"]')?.addEventListener('click', save);
    document.addEventListener('click', event => {
      const button = event.target.closest('[data-nx-newsletter-open]');
      if (button) modal.show(button);
    });
    if (location.pathname.includes('/challenge')) return;
    let previous;
    try { previous = JSON.parse(sessionStorage.getItem(pending)); sessionStorage.removeItem(pending); } catch (_) {}
    const form = previous && Date.now() - previous.time < 300000 ? document.getElementById(previous.id) : null;
    const result = form?.querySelector('[data-nx-result]');
    if (result) {
      if (result.dataset.nxResult === 'success') save();
      if (form.closest('#NuxeroCommunityPopup')) {
        modal.show(opener);
        if (typeof trapFocus === 'function') trapFocus(modal, result);
      } else result.focus({ preventScroll: false });
      return;
    }
    let last = 0;
    try { last = Number(localStorage.getItem(storage) || 0); } catch (_) {}
    if (document.querySelector('[data-nx-auto-popup]') && Date.now() - last > 7 * 86400000 && !/\/(cart|checkout)(?:\/|$)/.test(location.pathname)) setTimeout(() => {
      if (document.visibilityState === 'visible' && !document.querySelector('cart-drawer.active,modal-dialog[open],details[open].menu-opening')) {
        modal.show(opener); save();
      }
    }, 12000);
  };
  customElements.whenDefined('modal-dialog').then(init);
  document.addEventListener('shopify:section:load', init);
})();
